// file: /components/LinkButton.jsx
import React from 'react'
import appTheme from '../appTheme'
import PropTypes from 'prop-types'
import { withRouter, useLocation } from 'react-router'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import Button from '@mui/material/Button';
//import { ThemeProvider } from '@mui/styles';

const LinkButton = (props) => {
  const {
    history,
    location,
    match,
    staticContext,
    to,
    onClick,
    home,
    admin,
    // ⬆ filtering out props that `button` doesn’t know what to do with.
    ...rest
  } = props

  const currentLocation = useLocation();

  return (
    <ThemeProvider theme={appTheme}>
    <Button
      {...rest} // `children` is just another prop!
      key={ props.id }
      sx={{
        py: 0,
        // pl: 4,
        fontFamily: 'Calibri, Arial, Helvetica, sans-serif',
        fontSize: home ? '14px' : '1.05rem',
        color: home ? 'common.white' : admin ? 'error.dark' : (currentLocation.pathname === to) ? 'text.secondary' : 'text.textblue',
        bgcolor: 'inherit',
        fontWeight: home ? '600' : (currentLocation.pathname === to) ? 'bold' : 'regular',
        letterSpacing: '0.005em',
        textTransform: home ? 'uppercase' : 'none',
      }}
      onClick={(event) => {
        onClick && onClick(event)
        history.push(to)
      }}
    />
    </ThemeProvider>
  )
}

LinkButton.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default withRouter(LinkButton)